import React from "react";
import { Route, RouterProvider, Routes, createBrowserRouter } from "react-router-dom";
import Home from "../Routes/Home";
import ImageGallery from "../Routes/ImageGallery";
import Reviews from "../Routes/Reviews";
import ContactUs from "../Routes/ContactUs";
import UnderConstruction from "../Routes/UnderConstruction";

const Router = () => {

  return (
    <Routes>
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/gallery" element={<ImageGallery />} />
      <Route path="/reviews" element={<Reviews />} />
      {/* <Route path="/" element={<UnderConstruction />} /> */}
      <Route path="/" element={<Home />} />
    </Routes>
  );
};
export default Router;
